import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField, Box, Typography } from '@mui/material';
import { RemovableChipComponent } from 'components/RemovableChipComponent';

interface IMuiAutoCompleteProps {
  options: string[];
  label: string;
  placeholder: string;
  chipsHeader: string;
  errorFromForm: any;
  actionOnChange?: (data: string[]) => void;
  loadedOptions: string[];
  disabled: boolean;
}

function AutoCompleteComponent({
  options,
  label,
  placeholder,
  chipsHeader,
  errorFromForm,
  actionOnChange,
  loadedOptions,
  disabled
}: IMuiAutoCompleteProps) {
  const [value, setValue] = useState<string[]>([]);

  useEffect(() => {
    setValue(loadedOptions);
  }, [loadedOptions]);

  function deleteChip(chipToDelete: string) {
    setValue((value) => value.filter((chip) => chip !== chipToDelete));
    if (actionOnChange)
      actionOnChange(value.filter((chip) => chip !== chipToDelete));
  }

  function addChip(newData: string[]) {
    setValue(newData);
  }

  return (
    <>
      <Autocomplete
        renderTags={() => null}
        sx={{ width: '50%' }}
        multiple
        value={value}
        options={options}
        disabled={disabled}
        getOptionLabel={(option) => option}
        renderInput={(params) => (
          <TextField
            error={!!errorFromForm}
            helperText={errorFromForm ? errorFromForm.message : null}
            label={label}
            placeholder={placeholder}
            {...params}
            variant="standard"
            InputLabelProps={{
              shrink: true
            }}
          />
        )}
        onChange={(_, data) => {
          addChip(data);
          actionOnChange ? actionOnChange(data) : '';
        }}
      />
      <Box minHeight="fit-content">
        {value[0] ? (
          <Typography fontSize="14px" color="grey.900">
            {chipsHeader}
          </Typography>
        ) : (
          ''
        )}
        {value.map((value, index) => {
          return (
            <RemovableChipComponent
              key={index}
              chipTitle={value}
              deleteChip={() => deleteChip(value)}
            />
          );
        })}
      </Box>
    </>
  );
}
export { AutoCompleteComponent };
